import React, { useState, useEffect, useCallback } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";
import { Switch, Router, Link, Route, Redirect } from "react-router-dom";
import { RecoilRoot } from "recoil";
import { Main } from "./pages/Dashboard/Main/Main";
import { UploadFile } from "./pages/Dashboard/UploadFile/UploadFile";
import { Validate } from "./pages/Dashboard/Validate/Validate";
import Login from "./pages/Auth/Login";
import { useTypeSelector } from "./hooks/useTypeSelector";
import { useActions } from "./hooks/useActions";
import { LogOut } from "react-feather";
import httpClient from "./utils/httpClient";
import history from "./utils/history";

export const App = (): JSX.Element => {
  const { data: userData } = useTypeSelector((state) => state.user);
  const [userAuth, setUserAuth] = useState(true);
  const [appReady, setAppReady] = useState(false);

  const { getUserInfo } = useActions();

  const logout = useCallback(() => {
    httpClient.removeTokens();
    window.location.href = "/login";
  }, []);

  useEffect(() => {
    const accessToken = localStorage.getItem("accessToken");
    const refreshToken = localStorage.getItem("refreshToken");
    if (
      window.location.pathname === "/login" &&
      !accessToken &&
      !refreshToken
    ) {
      setAppReady(true);
      setUserAuth(false);
    } else {
      getUserInfo();
    }
  }, []);

  useEffect(() => {
    if (userData.name) {
      setAppReady(true);
      setUserAuth(true);
    }
  }, [userData]);

  if (!appReady) return <></>;

  if (!userAuth) {
    return (
      <Router history={history}>
        <Switch>
          <Route exact path={"/login"} component={Login} />
          <Route path="*">
            <Redirect to="/login" />
          </Route>
        </Switch>
      </Router>
    );
  }

  return (
    <Router history={history}>
      <div className="App d-flex flex-column h-100">
        <>
          <nav className="navbar navbar-dark sticky-top bg-dark flex-md-nowrap p-1 px-3">
            <Link to={"/"} className="navbar-brand col-sm-3 col-md-2 mr-0">
              DICOM загрузчик
            </Link>
            <div className="col-8">
              <div className="d-flex justify-content-end">
                <div className="header-login pr-3">{userData.name}</div>
                <div className="header-logout">
                  <div
                    className="btn btn-icon btn-logout rounded-circle waves-effect waves-float waves-light"
                    onClick={logout}
                  >
                    <LogOut size={20} color="#6E6B7B" />
                  </div>
                </div>
              </div>
            </div>
          </nav>
          <div className="d-flex justify-content-center bg-light flex-grow-1">
            <main className="main-page pt-5 px-5">
              <Switch>
                <RecoilRoot>
                  <Route exact path={"/"} component={Main} />
                  <Route exact path={"/upload"} render={() => <UploadFile />} />
                  <Route exact path={"/markup"} render={() => <Validate />} />
                  {userData?.roles?.includes("validator") && (
                    <Route
                      exact
                      path={"/validate"}
                      render={() => <Validate />}
                    />
                  )}
                  {/*<Route path="*">*/}
                  {/*  <Redirect to="/" />*/}
                  {/*</Route>*/}
                </RecoilRoot>
              </Switch>
            </main>
          </div>
        </>
      </div>
    </Router>
  );
};
